exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"typography.css","sourceRoot":""}]);

// exports
exports.locals = {
	"fontSize": "1em",
	"btnFontSize": ".8em",
	"fontSizeS": ".72em",
	"fontSizeM": ".9em",
	"fontSizeL": "1.25em",
	"fontWeightLight": "300",
	"fontWeightNormal": "400",
	"fontWeightMedium": "500",
	"fontWeightStrong": "700"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--0-1!./node_modules/postcss-loader/lib!./src/styles/typography.css
// module id = 1
// module chunks = 3